export const columns = [
  {
    name: 'Enzyme',
    selector: (row) => row.enzyme,
    width: '80px'
  },
  {
    name: 'Function',
    selector: (row) => row.function,
    width: '270px'
  },
  {
    name: 'Activity',
    selector: (row) => row.activity,
    width: '350px'
  },
  {
    name: 'Organism',
    selector: (row) => row.organism,
    width: '220px',
    id: 'results-organism'
  },
  {
    name: 'Molecular weight a',
    selector: (row) => row.molecularWeight,
    width: '150px'
  },
  {
    name: 'Isoelectric point a',
    selector: (row) => row.isoelectricPoint,
    width: '150px'
  },
  {
    name: 'Parts',
    selector: (row) => row.parts,
    id: 'results-parts'
  }
]

export const data = [
  {
    enzyme: 'P0DTR4',
    function: <span>N-acetyl-&alpha;-D-galactosamine deacetylase</span>,
    activity: (
      <span>
        <span>Blood group A</span>
        <br />
        <span>Removes acetyl group from N-acetyl-&alpha;-D-galactosamine</span>
        <br />
        <span>Works in pair with P0DTR5</span>
      </span>
    ),
    organism: <i>Flavonifractor plautii</i>,
    molecularWeight: '85.264 kDa',
    isoelectricPoint: '4.33',
    parts: <a href="http://parts.igem.org/Part:BBa_K4726000">BBa_K4726000</a>
  },
  {
    enzyme: 'P0DTR5',
    function: <span>&alpha;-D-galactosamine galactosaminidase</span>,
    activity: (
      <span>
        <span>Blood group A</span>
        <br />
        <span>Removes remaining &alpha;-D-galactosamine</span>
        <br />
        <span>Works in pair with P0DTR4</span>
      </span>
    ),
    organism: <i>Flavonifractor plautii</i>,
    molecularWeight: '119.530 kDa',
    isoelectricPoint: '4.37',
    parts: <a href="http://parts.igem.org/Part:BBa_K4726001">BBa_K4726001</a>
  },
  {
    enzyme: 'GH110b',
    function: <span>&alpha;-galactosidase 110b</span>,
    activity: (
      <span>
        <span>Blood group B</span>
        <br />
        <span>Removes &alpha;-galactose</span>
        <br />
        <span>Active towards branched and linear group B </span>
      </span>
    ),
    organism: <i>Bacteroides fragilis</i>,
    molecularWeight: '67.834 kDa',
    isoelectricPoint: '6.69',
    parts: <a href="http://parts.igem.org/Part:BBa_K4726002">BBa_K4726002</a>
  },
  {
    enzyme: 'NAGA',
    function: <span>&alpha;-N-Acetylgalactosaminidase 109A</span>,
    activity: (
      <span>
        <span>Blood group A</span>
        <br />
        <span>Removes N-acetyl-&alpha;-D-galactosamine</span>
      </span>
    ),
    organism: <i>Elizabethkingia meningoseptica</i>,
    molecularWeight: '51.164 kDa',
    isoelectricPoint: '6.66',
    parts: <a href="http://parts.igem.org/Part:BBa_K3717016">BBa_K3717016</a>
  },
  {
    enzyme: 'GH110a',
    function: <span>&alpha;-galactosidase 110a</span>,
    activity: (
      <span>
        <span>Blood group B</span>
        <br />
        <span>Removes &alpha;-galactose</span>
        <br />
        <span>Active towards branched group B</span>
      </span>
    ),
    organism: <i>Bacteroides fragilis</i>,
    molecularWeight: '69.143 kDa',
    isoelectricPoint: '7.09',
    parts: <a href="http://parts.igem.org/Part:BBa_K3717006">BBa_K3717006</a>
  }
]
